module.exports = __webpack_public_path__ + "img/legalEntity.2e872341.svg";